<template>
  <div style="width:100%;height:100%">
    <div class="sky-register">
      <div class="sky-register__header" />
      <div class="sky-register__main">
        <div class="sky-register__form-content">
          <el-form ref="registerForm" :model="registerForm" :rules="longByPhoneRule" class="sky-register__form">
            <div class="sky-register__form-header">
              <el-form-item class="sky-register__form-item">
                <div>
                  补充注册信息
                </div>
              </el-form-item>
            </div>
            <div class="sky-register__form-body">
              <el-form-item label="真实姓名" prop="realName" class="sky-register__form-item" ellipsis-message>
                <el-input v-model="registerForm.realName" placeholder="请填写你的真实姓名" name="realName" />
              </el-form-item>
              <el-form-item label="手机号码" prop="telephoneNum" class="sky-register__form-item">
                <el-input
                  v-model="registerForm.telephoneNum"
                  disabled
                  placeholder="请填写你的手机号码"
                  name="telephoneNum"
                />
              </el-form-item>
              <el-form-item label="邮箱" prop="email" class="sky-register__form-item">
                <el-input v-model="registerForm.email" placeholder="请填写你的邮箱" name="email" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click.native.prevent="handleBack">返回</el-button>
                <el-button :loading="loading" type="success" @click.native.prevent="handleRegister">提交</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>

      <div class="sky-login__bottom">
        <div class="sky-login__about">
          <div class="sky-login__about-left">
            <a target="_blank" class="sky-login__about-txt" href="https://ocs.ruijie.com.cn/?p=rcd">{{
              $t('login.online')
            }}</a>
            <span class="sky-login__about-txt">{{ $t('login.hotline') }}</span>
            <span class="sky-login__about-txt">{{ $t('login.rj') }}©2024</span>
          </div>
          <div class="sky-login__about-right" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Form, Input, Button, Tooltip } from 'element-ui'

import { registerOrLoginOnPhone } from '@/api/setting'

export default {
  name: 'Login',
  components: {
    [Form.name]: Form,
    [Input.name]: Input,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip
  },
  data() {
    return {
      registerForm: {
        userrealNameame: '',
        email: '',
        telephoneNum: null,
        verifyCode: null
      },
      loading: false,
      longByPhoneRule: {
        telephoneNum: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
        realName: [{ required: true, message: '请填写用户名', trigger: 'blur' }],
        email: [
          {
            pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: '请输入正确的邮箱',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    if (!this.$store.getters.phoneValidateCode) {
      this.$router.push({ path: '/login' })
    }
    this.registerForm.verifyCode = this.$store.getters.phoneValidateCode.verifyCode
    this.registerForm.telephoneNum = this.$store.getters.phoneValidateCode.telephoneNum
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    handleBack() {
      this.$router.push({ path: '/login' })
    },
    handleRegister() {
      this.$refs.registerForm.validate(valid => {
        if (valid) {
          this.loading = true
          registerOrLoginOnPhone(this.registerForm)
            .then(res => {
              this.$store
                .dispatch('LoginByPhone', this.registerForm)
                .then(() => {
                  this.$router.push({ path: '/dashboard' })
                })
                .catch(e => {
                  this.loading = false
                  throw e
                })
            })
            .catch(e => {
              this.loading = false
              throw e
            })
          // this.$store
          //   .dispatch('LoginByUsername', this.loginForm)
          //   .then(() => {
          //     this.$router.push({ path: '/dashboard' })
          //   })
          //   .catch(e => {
          //     this.loading = false
          //     throw e
          //   })
        }
      })
    },
    handleKeydown(e) {
      const keyCode = e.keyCode
      if (keyCode === 13 && !this.loading) {
        this.handleLogin()
      }
    }
  }
}
</script>

<style>
#login_container iframe {
  border: 0 !important;
  object-fit: contain;
}
#login_container {
  width: 250px;
  height: 250px;
  margin: auto;
}
</style>
